import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LandingPage from "./pages/landingPage/landingPage";
import ProductPage from "./pages/productPage/productPage";
import CategoryPage from "./pages/categoryPage/categoryPage";
import ComparePage from "./pages/comparePage/comparePage";
import DocumentList from "./pages/documentPage/documentList";
import Login from "./components/authentication/Login";
import Logout from "./components/authentication/Logout";
import AuthorizeRoute from "./components/authentication/AuthorizeRoute";
import Constants from "./helpers/Constants";
import AccessDeny from "./components/authentication/AccessDeny";
import MasterPage from "./pages/masterPage";
import SearchPage from "./pages/searchPage/searchPage";
import RateLimitPage from "./pages/landingPage/rateLimitPage";
import SocialMediaPage from "./pages/socialMediaPage";
import DocumentGroup from "./pages/documentPage/documentGroup";
import ProductManualsPage from "./pages/productManualsPage";

const App = () => {

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AuthorizeRoute />}>
          <Route
            path="/"
            element={
              <MasterPage>
                <LandingPage />
              </MasterPage>
            }
          />
          <Route
            path={"/model/:sku"}
            element={
              <MasterPage>
                <ProductPage />
              </MasterPage>
            }
          />
          <Route
            path="/category/:id"
            element={
              <MasterPage>
                <CategoryPage />
              </MasterPage>
            }
          />
          <Route
            path="/compare"
            element={
              <MasterPage>
                <ComparePage />
              </MasterPage>
            }
          />
          <Route
            path="/search"
            element={
              <MasterPage>
                <SearchPage />
              </MasterPage>
            }
          />
          <Route
            path="/documents/:category/list"
            element={
              <MasterPage>
                <DocumentList />
              </MasterPage>
            }
          />
          <Route
            path="/documents/:category/group"
            element={
              <MasterPage>
                <DocumentGroup />
              </MasterPage>
            }
          />
          <Route
            path={"/documents/social"}
            element={
              <MasterPage>
                <SocialMediaPage />
              </MasterPage>
            }
          />
          <Route
            path={"/documents/product-manuals"}
            element={
              <MasterPage>
                <ProductManualsPage />
              </MasterPage>
            }
          />
        </Route>
        <Route
          path={Constants.ApplicationPaths.AccessDeny}
          element={<AccessDeny />}
        />
        <Route
          path={Constants.ApplicationPaths.Ratelimit}
          element={<RateLimitPage />}
        />
        <Route
          path={Constants.ApplicationPaths.Login}
          element={<Login action={Constants.LoginActions.Login}></Login>}
        />
        <Route
          path={Constants.ApplicationPaths.LoginFailed}
          element={<Login action={Constants.LoginActions.LoginFailed}></Login>}
        />
        <Route
          path={Constants.ApplicationPaths.LoginCallback}
          element={
            <Login action={Constants.LoginActions.LoginCallback}></Login>
          }
        />
        <Route
          path={Constants.ApplicationPaths.LogOut}
          element={<Logout action={Constants.LogoutActions.Logout}></Logout>}
        />
        <Route
          path={Constants.ApplicationPaths.LogOutCallback}
          element={
            <Logout action={Constants.LogoutActions.LogoutCallback}></Logout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
